module.exports = __webpack_public_path__ + "static/media/essais.f7524a09.jpg";